import type { Ref } from 'react';
import { AlertDialog, AlertDialogButton, Text, theme } from '@frameio/vapor';
import TEXT from './generated/TEXT/RenameWarningDialog';

type Props = {
  isShowing: boolean;
  newExt: string;
  oldExt: string;
  onChangeClick: () => void;
  onExited: () => void;
  onKeepClick: () => void;
  ref: Ref<unknown>;
};

export const RenameWarningDialog = ({
  isShowing,
  newExt,
  oldExt,
  onChangeClick,
  onExited,
  onKeepClick,
  ref,
}: Props) => (
  <AlertDialog
    actions={
      <>
        <AlertDialogButton color="primary" onClick={onKeepClick}>
          {TEXT.keepOldExtension}
        </AlertDialogButton>
        <AlertDialogButton onClick={onChangeClick}>
          {TEXT.changeToExtension}
        </AlertDialogButton>
      </>
    }
    details={TEXT.changeExtensionDetails(oldExt, newExt)}
    isShowing={isShowing}
    leastDestructiveRef={ref}
    onExited={onExited}
    title={''}
    variant="notice"
  />
);

const WARNING_PADDING_TOP = 12;
const WARNING_PADDING_BOTTOM = 4;

TEXT.DEFINE(
  {
    changeExtensionDetails: (oldExt: string, newExt: string) => (
      <>
        <Text>
          Are you sure you want to change the file extension from "{oldExt}" to
          "{newExt}"?
        </Text>
        <Text
          style={{
            paddingBottom: theme.spaces[WARNING_PADDING_BOTTOM],
            paddingTop: theme.spaces[WARNING_PADDING_TOP],
          }}
          variant="secondary"
        >
          Your file type will remain unchanged.
        </Text>
      </>
    ),
    changeToExtension: 'Change',
    keepOldExtension: 'Keep',
  },
  { Text, theme, WARNING_PADDING_BOTTOM, WARNING_PADDING_TOP }
);
